import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { JwtModule } from "@auth0/angular-jwt";
import { HttpResponseInterceptor } from '@core/http-interceptors/http-response.interceptor';
import { LocalStorageService } from '@core/local-storage/local-storage.service';
import { AuthGuardService } from '@core/auth/auth-guard.service';
import { LoginGuardService } from '@core/auth/login-guard.service';
import { HttpErrorInterceptor } from '@core/http-interceptors/http-error.interceptor';
import { HttpRequestInterceptor } from '@core/http-interceptors/http-request.interceptor';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    //NgxPermissionsModule.forRoot(),
    JwtModule
  ],
  exports: [
    //NgxPermissionsModule,
    JwtModule
  ],
  providers: [
    LocalStorageService,
    AuthGuardService,
    LoginGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpResponseInterceptor, multi: true }
  ]
})
export class CoreModule { }
